'use client'

import * as React from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'
import { RadioGroup as RadioGroupPrimitive } from 'radix-ui'

const RadioGroup = React.forwardRef<
	React.ElementRef<typeof RadioGroupPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
	return (
		<RadioGroupPrimitive.Root
			className={cn('grid gap-2', className)}
			{...props}
			ref={ref}
		/>
	)
})

RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = React.forwardRef<
	React.ElementRef<typeof RadioGroupPrimitive.Item>,
	React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
	return (
		<RadioGroupPrimitive.Item
			className={cn(
				'border-foreground text-foreground focus-visible:ring-ring aspect-square h-[14px] w-[14px] rounded-full border focus:outline-hidden focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50',
				className,
			)}
			ref={ref}
			{...props}
		>
			<RadioGroupPrimitive.Indicator className='border-background bg-foreground flex h-full w-full items-center justify-center rounded-full border' />
		</RadioGroupPrimitive.Item>
	)
})

RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
